import React from "react";

const error = () => {
  return (
    <div style={{ minHeight: `calc(100vh - 3em - 2.5em)` }}>
      <h1>Page Not found</h1>
    </div>
  );
};

export default error;
